module.exports = __webpack_public_path__ + "img/logo_vipcard@2x.4e9e4967.png";